import type { ReactNode } from "react";
import { Anchor, Box, Group, Paper, Stack, Text } from "@mantine/core";
import { Link } from "react-router-dom";
import type { EcosystemHeadNavState } from "@/pages/ecosystem-heads/ecosystemHeads.const";
import { CARD_BORDER } from "../sectorEcosystem.const";

type SectorDashboardCardProps = {
  title: string;
  subtitle?: string;
  footerLabel?: string;
  footerTo?: string;
  footerLinkState?: EcosystemHeadNavState | { from: { pathname: string; search?: string; hash?: string } };
  footerComingSoon?: boolean;
  headerAction?: ReactNode;
  children: ReactNode;
};

export default function SectorDashboardCard({
  title,
  subtitle,
  footerLabel,
  footerTo,
  footerLinkState,
  footerComingSoon = false,
  headerAction,
  children,
}: SectorDashboardCardProps) {
  return (
    <Paper
      withBorder
      radius="md"
      p="md"
      h="100%"
      style={{ border: CARD_BORDER, backgroundColor: "#fff" }}
    >
      <Stack gap="sm" h="100%">
        <Group justify="space-between" align="flex-start" wrap="nowrap">
          <Box>
            <Text fw={700} c="#0F172A" size="sm">
              {title}
            </Text>
            {subtitle ? (
              <Text size="xs" c="dimmed" mt={2}>
                {subtitle}
              </Text>
            ) : null}
          </Box>
          {headerAction}
        </Group>
        <Box style={{ flex: 1 }}>{children}</Box>
        {footerComingSoon ? (
          <Text size="xs" fw={600} c="#64748B">
            Launching Soon
          </Text>
        ) : footerLabel && footerTo ? (
          <Anchor component={Link} to={footerTo} state={footerLinkState} size="xs" fw={600} c="primary.7">
            {footerLabel} →
          </Anchor>
        ) : null}
      </Stack>
    </Paper>
  );
}
